var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:['grid-item', _vm.className],style:(_vm.className === 'grid-item-search' ? _vm.searchStyle : '')},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }